import type { Board } from "./board";
import type { Player } from "./player";
import { Strings } from "./strings";

export abstract class CollectableItem {
	static key: string;
	count: number;

	constructor(count: number = 1) {
		this.count = count;
	}

	getNameKey(): string {
		return "iname_" + (this.constructor as any).key;
	}

	getName(): string {
		const translated = Strings.get(this.getNameKey());
		if (translated === null) return (this.constructor as any).key;
		return translated;
	}

	abstract pickupBy(player: Player, board: Board): CollectablePickupResult;

	isUsable(): boolean {
		return false;
	}

	getHotkeyLabel(): string | null {
		return null;
	}

	use(_player: Player, _board: Board): UseItemResult {
		return { consumed: false, turnPassed: false };
	}

	serialize(): Record<string, unknown> {
		return { type: (this.constructor as any).key, count: this.count };
	}
}

/** Returned by pickupBy so the LootBox can build its LootPickupEffect uniformly. */
export interface CollectablePickupResult {
	/** Key used to look up the icon (a weapon key for Ammo, an item key for Key/Medikit). */
	pickupKey: string;
	amount: number;
	/** True for infinite-ammo weapons (e.g. OpGun pickup) — affects popup text. */
	isInfinite: boolean;
}

/** Returned by CollectableItem.use() — drives inventory decrement and turn-pass decision. */
export interface UseItemResult {
	/** True if the item count should be decremented (use succeeded). */
	consumed: boolean;
	/** True if the player's turn should pass (mobs act). False = turn aborts. */
	turnPassed: boolean;
}
